import { render, staticRenderFns } from "./UnlayerEmailEditor.vue?vue&type=template&id=1054aad8&scoped=true"
import script from "./UnlayerEmailEditor.vue?vue&type=script&lang=js"
export * from "./UnlayerEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./UnlayerEmailEditor.vue?vue&type=style&index=0&id=1054aad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054aad8",
  null
  
)

export default component.exports